import {
  MenuButtonClickedContext,
  ContextValue as MenuButtonClickedContextValue,
} from 'globals/context/menu-button-callback-provider';
import { useContext } from 'react';

const INTERESTS_UPDATED = 'interests-updated';

export const useInterestsUpdatedHook = () => {
  const { addCallback, removeCallback, onClick } =
    useContext<MenuButtonClickedContextValue>(MenuButtonClickedContext);

  const registerInterestsUpdate = callback => {
    addCallback(INTERESTS_UPDATED, callback);
  };

  const unregisterInterestsUpdate = callback => {
    removeCallback(INTERESTS_UPDATED, callback);
  };

  const notifyUpdate = () => {
    onClick(INTERESTS_UPDATED);
  };

  return {
    notifyUpdate,
    registerInterestsUpdate,
    unregisterInterestsUpdate,
  };
};
